import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import NutritionPage from './pages/NutritionPage';
import MealPlansPage from './pages/MealPlansPage';
import ConsultationsPage from './pages/ConsultationsPage';
import NutritionShopPage from './pages/NutritionShopPage';
import MediaPage from './pages/MediaPage';
import FashionPage from './pages/FashionPage';
import ContactPage from './pages/ContactPage';
import CartPage from './pages/CartPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import CheckoutCancelPage from './pages/CheckoutCancelPage';
import DashboardPage from './pages/DashboardPage';
import OrdersPage from './pages/OrdersPage';

import './index.css';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-[#0A0A0A]">
            {/* Grain Overlay */}
            <div className="grain-overlay" />
            
            {/* Navbar */}
            <Navbar />
            
            {/* Main Content */}
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                
                {/* Nutrition Routes */}
                <Route path="/nutrition" element={<NutritionPage />} />
                <Route path="/nutrition/shop" element={<NutritionShopPage />} />
                <Route path="/nutrition/meal-plans" element={<MealPlansPage />} />
                <Route path="/nutrition/consultations" element={<ConsultationsPage />} />
                
                {/* Media Routes */}
                <Route path="/media" element={<MediaPage />} />
                <Route path="/media/portfolio" element={<MediaPage />} />
                <Route path="/media/services" element={<MediaPage />} />
                <Route path="/media/booking" element={<MediaPage />} />
                
                {/* Fashion Routes */}
                <Route path="/fashion" element={<FashionPage />} />
                <Route path="/fashion/customize" element={<FashionPage />} />
                
                {/* Contact */}
                <Route path="/contact" element={<ContactPage />} />
                
                {/* Cart & Checkout */}
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
                <Route path="/checkout/cancel" element={<CheckoutCancelPage />} />
                
                {/* User Routes */}
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/orders" element={<OrdersPage />} />
              </Routes>
            </main>
            
            {/* Footer */}
            <Footer />
            
            {/* Toast Notifications */}
            <Toaster 
              position="top-right"
              toastOptions={{
                style: {
                  background: '#1A1514',
                  color: '#F5F2EB',
                  border: '1px solid rgba(229, 211, 179, 0.2)',
                },
              }}
            />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
